import { BusinessServices } from 'src/app/kuba/businesses/services/business.services';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

import { BusinessDepartmentService } from './../../business-department.services';
import { BusinessDepartment, Employee, EmployeePosition } from '../models/';
import { BaseServices } from './../../kuba.services';
import { Timetable } from './../../time-table/models/timetable';
import { BusinessCourse } from './../models/employeeCourse';
import { EmployeeSicknessAbscence } from './../models/employeeSicknessAbscence';
import { EmployeeServices } from './employee.services';
import { EmployeeCourseServices } from './employeecourse.service';
import { EmployeeLeaveService } from './employeeleave.service';
import { EmployeeSicknessServices } from './employeesickness.service';
import { tap } from 'rxjs/operators';
import { Roles } from 'src/app/_models';

@Injectable()
export class EmployeeListResolver {
  constructor(private backend: EmployeeServices) {}
  resolve(): Observable<Employee[]> {
    // Quick fix for getting portal employees as portal user
    if (BaseServices.roleId === '2') {
      return null;
      //return this.backend.portalList(BaseServices.PortalId);
    }
    // Regular list (non-portal)
    return this.backend.list(BaseServices.BusinessId);
  }
}
@Injectable()
export class PortalEmployeeListResolver {
  constructor(private backend: EmployeeServices) {}
  resolve(): Observable<any> {
    const defaultFilter = {
      PageNumber: 1,
      PageSize: 1000,
      SortColumn: 'Name',
      SortDirection: 'ASC'
    };
    return this.backend.getPagedPortalList(BaseServices.PortalId, defaultFilter);
  }
}
@Injectable()
export class EmployeeEditResolver {
  constructor(private backend: EmployeeServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    if (+route.params['eid'] > 0) {
      return this.backend.getById(+route.params['eid']);
    } else {
      return null!;
    }
  }
}

@Injectable()
export class EmployeeSubDepartmentResolver {
  departmentId: number;
  constructor(private backend: EmployeeServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    const employeeId = +route.params['eid'];
    if (employeeId === 0) {
      return null;
    }
    return this.backend.getSubDepartmentByEmployee(+route.params['eid']);
  }
}

@Injectable()
export class EmployeeSicknessListResolver
{
  constructor(private backend: EmployeeSicknessServices) {}
  resolve(): Observable<EmployeeSicknessAbscence[]> {
    if (BaseServices.roleId === '2') {
      return this.backend.portalList(BaseServices.UserId);
    } else {
      return this.backend.list(BaseServices.BusinessId);
    }
  }
}
@Injectable()
export class PortalEmployeeSicknessListResolver
{
  constructor(private backend: EmployeeSicknessServices) {}
  resolve(): Observable<EmployeeSicknessAbscence[]> {
    if (BaseServices.roleId === '2') {
      return this.backend.portalList(BaseServices.UserId);
    }
    return null!;
  }
}

@Injectable()
export class EmployeeSicknessByIdResolver
{
  constructor(private backend: EmployeeSicknessServices) {}
  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<EmployeeSicknessAbscence[]> {
    if (+route.params['sid'] > 0) {
      let res: any = this.backend.getById(+route.params['sid']);
      return res;
    } else {
      return null!;
    }
  }
}
// Course Edit
@Injectable()
export class CourseEditResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.params['eid']);
  }
}
// Course list
@Injectable()
export class CourseListResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve() {
    if (BaseServices.roleId !== '2') {
      return this.backend.list(BaseServices.BusinessId);
    } else {
      return null!;
    }
  }
}
// Contract list
@Injectable()
export class CourseListContractResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve() {
    if (BaseServices.roleId !== '2') {
      return this.backend.listcontract(BaseServices.BusinessId);
    } else {
      return null!;
    }
  }
}
// Course list by user
@Injectable()
export class PortalCourseListResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve() {
    if (BaseServices.roleId === '2') {
      return this.backend.portalList(BaseServices.UserId);
    } else {
      return null!;
    }
  }
}
// Course list by user
@Injectable()
export class PortalContractListResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve() {
    if (BaseServices.roleId === '2') {
      return this.backend.portalListContract(BaseServices.UserId);
    } else {
      return null!;
    }
  }
}
@Injectable()
export class BusinessCourseResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    let url = route.url[0].path;
    let IsEmployeeCourse;
    if (url == 'contractlist' || url == 'editContract') {
      IsEmployeeCourse = false;
    } else {
      IsEmployeeCourse = true;
    }
    if (+BaseServices.roleId === Roles.PORTAL) {
      return this.backend.getAllByPortalCourseName(
        +BaseServices.PortalId,
        IsEmployeeCourse
      );
    } else {
      return this.backend.getAllByCourseName(
        +BaseServices.BusinessId,
        IsEmployeeCourse
      );
    }
  }
}

// COntract Resolver
@Injectable()
export class BusinessContractResolver {
  constructor(private backend: EmployeeCourseServices) {}
  resolve() {
    return this.backend.getAllByContractName(BaseServices.BusinessId).pipe(
      tap(data => {
        console.log(data);
      })
    );
  }
}

@Injectable()
export class EmployeeTimeTableResolver {
  constructor(private backend: EmployeeServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getTimeTableByEmployeeId(+route.params['eid']);
  }
}

@Injectable()
export class DepartmentDropDownResolver
{
  constructor(private backend: BusinessDepartmentService) {}
  resolve() {
    return this.backend.getCachedBusinessDepartment();
  }
}
@Injectable()
export class EmployeeDocResolver {
  constructor(private backend: EmployeeServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    if (+route.params['eid'] > 0) {
      let listDoc: any = this.backend.listDoc(+route.params['eid']);
      return listDoc;
    }
  }
}
@Injectable()
export class PositionDropDownResolver {
  constructor(private backend: EmployeeServices) {}
  resolve() {
    return this.backend.getAllByPosition(BaseServices.BusinessId);
  }
}
@Injectable()
export class EmployeeDropDownResolver {
  constructor(private backend: EmployeeServices) {}
  resolve() {
    return this.backend.getAllByType(BaseServices.BusinessId);
  }
}
@Injectable()
export class EmployeeLeaveResolver {
  constructor(private backend: EmployeeLeaveService) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getEmployeeLeavesByEmployeeId(+route.params['eid']);
  }
}

@Injectable()
export class EmployeeActiveStatusResolver {
  constructor(private backend: EmployeeServices) {}
  resolve() {
    if (BaseServices.roleId !== '2') {
      return this.backend.getActiveEmployees(BaseServices.BusinessId);
    }
    return null;
  }
}

@Injectable()
export class BusinessAbsenceCodesBusinessResolver {
  constructor(private backend: EmployeeSicknessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getSicknessAbsenceCode(BaseServices.BusinessId);
  }
}
@Injectable()
export class UserDetailsResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getByUserId(BaseServices.UserId);
  }
}
@Injectable()
export class EmployeeBusinessDataResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(BaseServices.BusinessId);
  }
}
